import logoTransparent from "../assets/logo-transparent.svg";

export default function Footer() {
  return (
      <footer>
        <div className="max-w-7xl mx-auto px-6">
          <div className="pt-10 lg:pt-18">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-4/12">
                <div>
                  <a href="/" className="mb-10 lg:mb-20 inline-block">
                    <img src="/images/logo/logo-square.webp" alt="CV Box Logo" className="h-25 w-auto object-contain" width={200} height={200} />
                  </a>
                  <p className="lg:pr-10 text-gray-500 text-base">
                    Build your professional profile, track jobs, and generate tailored application materials with AI. Get compatibility reports, optimized CVs, cover letters, and career coaching with Job Agent. Trusted by 1,200+ job seekers worldwide.
                  </p>
                </div>
              </div>
              <div className="lg:w-6/12 lg:ml-auto">
                <div className="grid grid-cols-2 gap-5 sm:gap-10 sm:grid-cols-3">
                  <div>
                    <h3 className="text-lg text-gray-800 font-medium mb-6">
                      Product
                    </h3>
                    <nav className="space-y-5">
                      <a
                          href="/"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Home
                      </a>
                      <a
                          href="/features"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Features
                      </a>
                      <a
                          href="/pricing"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Pricing
                      </a>
                    </nav>
                  </div>
                  <div>
                    <h3 className="text-lg text-gray-800 font-medium mb-6">
                      Company
                    </h3>
                    <nav className="space-y-5">
                      <a
                          href="/contact"
                          className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                      >
                        Contact
                      </a>
                      <a href="/privacy" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Privacy Policy
                      </a>
                      <a href="/cookie" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Cookie Policy
                      </a>
                      <a href="/returns" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Returns Policy
                      </a>
                      <a href="/terms" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Terms of Service
                      </a>
                      <a href="/acceptable-use" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Acceptable Use Policy
                      </a>
                      <a href="/company" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                        Business Details
                      </a>
                    </nav>
                  </div>
                  {/*<div className="flex lg:justify-end">*/}
                  {/*  <div>*/}
                  {/*    <h3 className="text-lg text-gray-800 font-medium mb-6">*/}
                  {/*      Social*/}
                  {/*    </h3>*/}
                  {/*    <nav className="space-y-5">*/}
                  {/*      <a*/}
                  {/*          href="https://discord.gg/cvbox"*/}
                  {/*          target="_blank"*/}
                  {/*          rel="noopener noreferrer"*/}
                  {/*          className="flex items-center gap-2 text-gray-700 hover:text-indigo-500 transition-colors duration-300 ease-in-out"*/}
                  {/*      >*/}
                  {/*        <svg*/}
                  {/*            xmlns="http://www.w3.org/2000/svg"*/}
                  {/*            width="20"*/}
                  {/*            height="20"*/}
                  {/*            viewBox="0 0 20 20"*/}
                  {/*            fill="none"*/}
                  {/*        >*/}
                  {/*          <path*/}
                  {/*              d="M12.9174 14.7915L13.9952 16.2669C14.0964 16.4271 14.2908 16.4986 14.4683 16.4352C15.1381 16.1959 16.7984 15.5475 18.1654 14.5603C18.272 14.4833 18.3335 14.3549 18.3327 14.2226C18.3327 6.87484 16.2507 4.7915 16.2507 4.7915C16.2507 4.7915 14.584 3.83494 12.7956 3.54652C12.6197 3.51814 12.4474 3.61241 12.3691 3.77393L11.9983 4.53881C11.9983 4.53881 11.0711 4.34481 10 4.34481C8.92895 4.34481 8.00178 4.53881 8.00178 4.53881L7.63096 3.77393C7.55265 3.61241 7.3804 3.51814 7.20444 3.54652C5.41736 3.83473 3.75069 4.7915 3.75069 4.7915C3.75069 4.7915 1.66737 6.87484 1.66737 14.2226C1.66653 14.3549 1.72808 14.4833 1.83469 14.5603C3.20167 15.5475 4.86195 16.1959 5.53175 16.4352C5.70924 16.4986 5.90368 16.4271 6.00488 16.2669L7.08402 14.7915"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*              strokeLinecap="round"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*          <path*/}
                  {/*              d="M14.584 13.9585C14.584 13.9585 12.6714 15.2085 10.0007 15.2085C7.32992 15.2085 5.41736 13.9585 5.41736 13.9585"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*              strokeLinecap="round"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*          <path*/}
                  {/*              d="M14.3757 10.2082C14.3757 11.1287 13.7227 11.8748 12.9173 11.8748C12.1119 11.8748 11.459 11.1287 11.459 10.2082C11.459 9.28767 12.1119 8.5415 12.9173 8.5415C13.7227 8.5415 14.3757 9.28767 14.3757 10.2082Z"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*          />*/}
                  {/*          <path*/}
                  {/*              d="M8.54229 10.2082C8.54229 11.1287 7.88936 11.8748 7.08394 11.8748C6.27854 11.8748 5.62561 11.1287 5.62561 10.2082C5.62561 9.28767 6.27854 8.5415 7.08394 8.5415C7.88936 8.5415 8.54229 9.28767 8.54229 10.2082Z"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*          />*/}
                  {/*        </svg>*/}
                  {/*        Discord*/}
                  {/*      </a>*/}
                  {/*      <a*/}
                  {/*          href="https://twitter.com/cvbox"*/}
                  {/*          target="_blank"*/}
                  {/*          rel="noopener noreferrer"*/}
                  {/*          className="flex items-center gap-2 text-gray-700 hover:text-indigo-500 transition-colors duration-300 ease-in-out"*/}
                  {/*      >*/}
                  {/*        <svg*/}
                  {/*            xmlns="http://www.w3.org/2000/svg"*/}
                  {/*            width="20"*/}
                  {/*            height="20"*/}
                  {/*            viewBox="0 0 20 20"*/}
                  {/*            fill="none"*/}
                  {/*        >*/}
                  {/*          <path*/}
                  {/*              d="M2.5 17.5L8.79033 11.2097M8.79033 11.2097L2.5 2.5H6.66667L11.2097 8.79033M8.79033 11.2097L13.3333 17.5H17.5L11.2097 8.79033M17.5 2.5L11.2097 8.79033"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*              strokeLinecap="round"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*        </svg>*/}
                  {/*        X (Twitter)*/}
                  {/*      </a>*/}
                  {/*      <a*/}
                  {/*          href="https://t.me/cv_box"*/}
                  {/*          target="_blank"*/}
                  {/*          rel="noopener noreferrer"*/}
                  {/*          className="flex items-center gap-2 text-gray-700 hover:text-indigo-500 transition-colors duration-300 ease-in-out"*/}
                  {/*      >*/}
                  {/*        <svg*/}
                  {/*            xmlns="http://www.w3.org/2000/svg"*/}
                  {/*            width="20"*/}
                  {/*            height="20"*/}
                  {/*            viewBox="0 0 20 20"*/}
                  {/*            fill="none"*/}
                  {/*        >*/}
                  {/*          <path*/}
                  {/*              d="M9.98779 12.8402L12.689 15.9113C13.6897 17.0491 14.1901 17.618 14.7139 17.4795C15.2376 17.341 15.4173 16.5923 15.7765 15.0948L17.769 6.78825C18.3223 4.48193 18.5989 3.32878 17.984 2.76C17.3691 2.19122 16.3033 2.61437 14.1717 3.46068L4.28226 7.38707C2.5774 8.06395 1.72497 8.40242 1.67085 8.984C1.66531 9.0435 1.66522 9.10342 1.67058 9.16292C1.72291 9.74475 2.5743 10.0861 4.27709 10.7686C5.04861 11.0778 5.43438 11.2325 5.71096 11.5287C5.74206 11.5619 5.77196 11.5964 5.80061 11.632C6.05544 11.9487 6.1642 12.3642 6.38169 13.1953L6.78874 14.7508C7.00038 15.5596 7.1062 15.964 7.38336 16.0192C7.66052 16.0742 7.90184 15.7389 8.38446 15.0682L9.98779 12.8402ZM9.98779 12.8402L9.72296 12.5642C9.42154 12.2501 9.27088 12.0931 9.27088 11.8979C9.27088 11.7027 9.42154 11.5457 9.72296 11.2315L12.7005 8.12841"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*              strokeLinecap="round"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*        </svg>*/}
                  {/*        Telegram*/}
                  {/*      </a>*/}
                  {/*      <a*/}
                  {/*          href="https://instagram.com/cvbox"*/}
                  {/*          target="_blank"*/}
                  {/*          rel="noopener noreferrer"*/}
                  {/*          className="flex items-center gap-2 text-gray-700 hover:text-indigo-500 transition-colors duration-300 ease-in-out"*/}
                  {/*      >*/}
                  {/*        <svg*/}
                  {/*            xmlns="http://www.w3.org/2000/svg"*/}
                  {/*            width="20"*/}
                  {/*            height="20"*/}
                  {/*            viewBox="0 0 20 20"*/}
                  {/*            fill="none"*/}
                  {/*        >*/}
                  {/*          <path*/}
                  {/*              d="M2.08337 10.0002C2.08337 6.26821 2.08337 4.40224 3.24274 3.24286C4.40212 2.0835 6.26809 2.0835 10 2.0835C13.732 2.0835 15.598 2.0835 16.7574 3.24286C17.9167 4.40224 17.9167 6.26821 17.9167 10.0002C17.9167 13.7321 17.9167 15.5981 16.7574 16.7575C15.598 17.9168 13.732 17.9168 10 17.9168C6.26809 17.9168 4.40212 17.9168 3.24274 16.7575C2.08337 15.5981 2.08337 13.7321 2.08337 10.0002Z"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*          <path*/}
                  {/*              d="M13.75 10C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 10C6.25 7.92893 7.92893 6.25 10 6.25C12.0711 6.25 13.75 7.92893 13.75 10Z"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.25"*/}
                  {/*          />*/}
                  {/*          <path*/}
                  {/*              d="M14.5898 5.4165H14.5823"*/}
                  {/*              stroke="currentColor"*/}
                  {/*              strokeWidth="1.66667"*/}
                  {/*              strokeLinecap="round"*/}
                  {/*              strokeLinejoin="round"*/}
                  {/*          />*/}
                  {/*        </svg>*/}
                  {/*        Instagram*/}
                  {/*      </a>*/}
                  {/*    </nav>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-between flex-col sm:flex-row gap-5 items-center pb-10 pt-10 lg:pt-20">
            <p className="text-base text-gray-500">
              © 2025 - {new Date().getFullYear()} CV Box. All rights reserved.
            </p>
            <div className="flex gap-3 items-center text-gray-700">
              Back to top
              <button
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  className="size-7 rounded-full text-white bg-indigo-500 inline-flex items-center justify-center hover:bg-indigo-600 transition duration-300 ease-in-out cursor-pointer"
                  aria-label="Back to top"
              >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                  <path
                      d="M10.2053 2.79053C10.2486 2.79053 10.291 2.7952 10.3323 2.80225C10.481 2.82707 10.6238 2.89561 10.7385 3.01025L15.7385 8.00635C16.0315 8.29911 16.0312 8.7739 15.7385 9.06689C15.4457 9.3598 14.971 9.36059 14.678 9.06787L10.9553 5.34619L10.9553 16.8745C10.9553 17.2887 10.6195 17.6245 10.2053 17.6245C9.7912 17.6244 9.45538 17.2886 9.45532 16.8745L9.45532 5.35205L5.73853 9.06787C5.44554 9.36055 4.97074 9.35982 4.67798 9.06689C4.38532 8.77392 4.3851 8.29912 4.67798 8.00635L9.6604 3.02686C9.67433 3.01208 9.68927 2.99847 9.70435 2.98486C9.72164 2.96917 9.73972 2.95471 9.75806 2.94092C9.84661 2.87472 9.94909 2.82606 10.0618 2.8042C10.064 2.80375 10.0663 2.80365 10.0686 2.80322C10.113 2.79504 10.1586 2.79054 10.2053 2.79053Z"
                      fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </footer>
  );
}